(function desktopNavigation() {

	let menuActive = false;
	let closeMenuTimeout = null;
	let changeMenuTimeout = null;
	let nextMenu = null;
	let currentActiveMenu = null;
	let mainNavElements = document.querySelectorAll('.desktop-nav-item');
	let mainNavDropdowns = document.querySelectorAll('.js-submenu');
	
	document.querySelectorAll('.js-group').forEach(item => {
		item.addEventListener('mouseover', event => {
	  
		  let target = findParent(event, '.js-group');
	  
		  clearTimeout(closeMenuTimeout);
		  clearTimeout(changeMenuTimeout);
	  
		  // If we have an active menu, allow a grace period in case mouse grazes over it when intent is to get mouse into submenu
		  if(menuActive) {
			nextMenu = item;
			changeMenuTimeout = setTimeout(() => {
			  // set classes to activate menu
			  if(currentActiveMenu != target) {
				currentActiveMenu.querySelector('.js-submenu').classList.add('hidden');
				target.querySelector('.js-submenu').classList.remove('hidden');
				currentActiveMenu = target;
			  }
			}, 150);
		  } else {
			// New mouseover, so open straight away
			target.querySelector('.js-submenu').classList.remove('hidden');
			menuActive = true;
			currentActiveMenu = target;
		  }
	  
		  // Set siblings so we can grey them out
		  mainNavElements.forEach(item => {
			  item.classList.add('opacity-50');
		  });
	  
		  target.querySelector('.desktop-nav-item').classList.remove('opacity-50');
		})
	  
		// Add a grace period for exiting menu. Has to be longer than the switch menu
		item.addEventListener('mouseout', event => {
		  closeMenuTimeout = setTimeout(() => {
			menuActive = false;
			if(currentActiveMenu) {
			  currentActiveMenu.querySelector('.js-submenu').classList.add('hidden');
			}
			mainNavElements.forEach(item => {
			  item.classList.remove('opacity-50');
		  });
		  }, 300);
		});
	  
		// Keyboard accessbility
		item.querySelector('a').addEventListener("click",  function(event){
	  
		  let menu = findParent(event, '.js-group');
		  let submenu = menu.querySelector('.js-submenu');
		  submenu.classList.toggle('hidden');
	  
		  // Set all other menus to hidden
		  mainNavDropdowns.forEach(item => {
			if(item != submenu) {
			  item.classList.add('hidden');
			}
		  });
	  
		  event.preventDefault();
		  });
	  });
	
	  function findParent(event, parentClass) {
		let target = null;
	  
		// Get the js-group item by traversing through parents (the event target will be the child mouseover html element rather than the element with the trigger)
		for (target = event.target; target && target != this; target = target.parentNode) {
		  if (target.matches(parentClass)) {
			  break;
		  }
		}
	  
		return target;
	  }

	  document.addEventListener("scroll", function(e) {
		document.body.classList.toggle('has-scrolled', window.scrollY >= 100);
	  }, {passive: true});

	  // Apply has scroll to catch refresh
	  document.body.classList.toggle('has-scrolled', window.scrollY >= 100);
})();

document.querySelectorAll('.js-scroll').forEach(el => {
	el.addEventListener('click', (event) => {
		let container = findParent(el, '.js-scroller-container');		
		let scrollers = container.querySelectorAll('.js-scroller');

		let scroller = scrollers.length == 1 ? scrollers[0] : container.querySelector('.active .js-scroller');
		let currentLeft = scroller.scrollLeft;
		let width = el.dataset.direction == 'left' ? -container.offsetWidth : container.offsetWidth;

		scroller.scrollTo({ left: currentLeft + width, behavior: 'smooth' });		
	});
});

/*
 * Size preference
 */
let sizeSelectorSelect = document.querySelector('.js-size-preference');

if(sizeSelectorSelect) {
	sizeSelectorSelect.addEventListener('change', (e) => {
		addCartAttribute('size_pref', e.target.value);
	});
}

function addCartAttribute(key, value) {
	fetch(window.Shopify.routes.root + 'cart.js', {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({
		'attributes': {
			[key]: value
		}
		})
	}).then(r => { location.reload(); })
}

/*
 * Utils
 */
function findParent(el, parentClass) {
	let target = null;  

	for (target = el; target && target != this; target = target.parentNode) {
		if (target.matches(parentClass)) {		
			break;
		}
	}

	return target;
}

window.sizeMap = {
	'5.5 - 7.5': { 'EU': '37 - 38', 'US': '4.5 - 6.5'},
	'8 - 10': { 'EU': '39 - 41', 'US': '7 - 9'},
	'10.5 - 12.5': { 'EU': '42 - 44', 'US': '9.5 - 11.5'},
	'13 - 14.5': { 'EU': '45 - 46', 'US': '12 - 13.5'},
}

document.addEventListener('alpine:initializing', () => {
	Alpine.data('mobileMenu', () => ({
		open: false,
		init() {
			this.$watch('open', () => {
				if(window.scrollY < 50) {
					// Make sure top message has scrolled away
					window.scrollTo({
						top: 50,
						left: 0,
						behavior: 'smooth'
					});
				}
			})
		},
		events: {
			['@mobile-menu.window']($event) {
				this.open = $event.detail.open
			},
			['@mobile-menu-close.window']() {
				this.open = false;
			}
		}
	}));

	Alpine.data('instantSearch', () => ({
		open: false,
		q: '',
		mode: 'init',
		init() {
			this.$watch('open', (v) => {
				if(v) {
					this.$nextTick(() => this.focus());
				}
			});
		},
		focus() {
			let searchInput = this.$refs.search;
			searchInput.focus();
			searchInput.select();
		},
		getResults() {
			let searchTerm = this.q.trim();

			if(searchTerm.length < 3) {
				this.mode = 'init';
				return;
			}		

			let url = `${window.Shopify.routes.root}search/suggest?q=${searchTerm}&section_id=predictive-search&resources[options][fields]=title,product_type,variants.title,variants.sku`;

			sectionReplace(url, 'instant', 'predictive-search-results', () => this.mode = 'results');			
		}
	}));

	Alpine.data('qtyChanger', (qty, lineIndex) => ({
		qty: qty,
		message: '',
		lineIndex: lineIndex,
		locked: false,
		down: function() {
			this.change(this.qty - 1);
		},
		up: function() {
			this.change(this.qty + 1);
		},
		change: async function(q) {
			this.locked = true;
			try {
				const result = await changeQuantity(this.lineIndex, q);
				this.locked = false;
			} catch(error) {
				this.message = error;
				this.locked = false;
				setTimeout(() => this.message = '', 3000);
			}
		},
	}));

	Alpine.store('config', {
		sockSize: Alpine.$persist('UK'),
		setSockSize(value) {
			this.sockSize = value;
		}
	});

	Alpine.store('wishlist', {
		productIds: Alpine.$persist([]),
		toggle(productId) {
			const id = String(productId);
			const index = this.productIds.indexOf(id);
			if (index === -1) {
				this.productIds = [...this.productIds, id];
			} else {
				this.productIds = this.productIds.filter((pid) => pid !== id);
			}
		},
		hasWishlist() {
			return this.productIds.length > 0;
		},
		isWishlist(productId) {
			return this.productIds.includes(String(productId));
		},
		load() {
			const ids = Alpine.store('wishlist').productIds;
			if (!ids.length) {
				return;
			}
			const q = ids.map((id) => `id:${id}`).join(' OR ');
			const url = `${window.Shopify.routes.root}search?q=${encodeURIComponent(q)}&view=wishlist`;
			
			sectionReplace(url, 'wishlist-content', 'remote-wishlist')
		}
	});
});

document.querySelectorAll('.js-add-product-form').forEach(form => {
	form.addEventListener('submit', (event) => {
		event.preventDefault();
		const formData = new FormData(form);

		formData.append('sections', 'right-push-out');
		form.dispatchEvent(new CustomEvent('adding', { bubbles: true }));  

		fetch(window.Shopify.routes.root + 'cart/add.js', {
			method: 'POST',
			body: formData
		  })
			.then(response => { return response.json();})
			.then(response => {
				if(response.sections['right-push-out']) {
					swapInSection('push-cart', response.sections['right-push-out'], 'push-cart');
				}
				window.dispatchEvent(new CustomEvent('right-panel', { detail: { content: 'cart' }, bubbles: true }));  
			});
	});
});

document.getElementById('push-cart-wrapper').addEventListener('click', (event) => {
	if(event.target.classList.contains('js-remove-item')) {
		event.preventDefault();
		changeQuantity(event.target.dataset.index, 0);		
	}
});

function sectionReplace(url, onPageTargetID, remoteTargetID, callback) {
	fetch(url)
	  .then(response => { return response.text();})
	  .then(response => {
		swapInSection(onPageTargetID, response, remoteTargetID);
		if(callback) {
			callback();
		}
	  })
  }

function swapInSection(onPageTargetId, remoteMarkup, remoteId) {

	let targetEl = document.getElementById(onPageTargetId);

	if(!targetEl) {
		return;
	}

	targetEl.innerHTML = new DOMParser().parseFromString(remoteMarkup, 'text/html').getElementById(remoteId).innerHTML;
}

async function changeQuantity(index, qty) {
	const response = await fetch(config.routes.cart_change_url + '.js', {
		method: "POST",
		headers: {
		  'Content-Type': 'application/json'
		},
		body: JSON.stringify({ line: index, quantity: qty, sections: "cart,right-push-out" })
	  });

	const data = await response.json();
	  
	if(!response.ok) {
		throw new Error(data.message);
	}
			
	if(data.sections) {
		swapInSection('shopping-cart', data.sections.cart, 'shopping-cart');
		swapInSection('push-cart', data.sections['right-push-out'], 'push-cart');
	}

	return true;
}